var map = {
	"./BAT-logo.png": 357,
	"./BUSD-logo.png": 358,
	"./COMP-logo.png": 359,
	"./CRV-icon.png": 608,
	"./CRV-logo.jpg": 1402,
	"./CRV-logo.png": 360,
	"./DAI-logo.png": 361,
	"./ERPH0DMWsAEWBjy.jpg": 1403,
	"./ETH-icon.png": 609,
	"./ETH-logo.png": 362,
	"./FTM-logo.png": 363,
	"./IEARN-icon.png": 610,
	"./KNC-logo.png": 364,
	"./LEND-logo.png": 365,
	"./LINK-logo.png": 366,
	"./MANA-logo.png": 367,
	"./MKR-logo.png": 368,
	"./REP-logo.png": 369,
	"./SAI-logo.png": 370,
	"./SNX-logo.png": 371,
	"./SUSD-logo.png": 372,
	"./TUSD-logo.png": 235,
	"./USDC-icon.png": 611,
	"./USDC-logo.png": 373,
	"./USDT-icon.png": 612,
	"./USDT-logo.png": 374,
	"./YFI-logo.png": 375,
	"./ZRX-logo.png": 376,
	"./aLINK-logo.png": 377,
	"./aave.png": 613,
	"./aave.svg": 586,
	"./alchemy.png": 614,
	"./bg-dark.png": 134,
	"./bg-light.png": 615,
	"./bg-waves.svg": 234,
	"./bg.png": 236,
	"./bzx.png": 616,
	"./cUSDC-logo.png": 378,
	"./cUSDT-logo.png": 379,
	"./check.svg": 587,
	"./coinbaseWalletIcon.svg": 337,
	"./coming-soon.png": 338,
	"./compound.png": 617,
	"./curvefi.jpg": 1404,
	"./ddex.jpg": 1405,
	"./ddex.png": 618,
	"./defipulse.png": 619,
	"./defisnap.svg": 588,
	"./defizap.png": 620,
	"./dydx.jpg": 1406,
	"./dydx.svg": 589,
	"./ethereum.png": 621,
	"./etherscan.png": 622,
	"./fonts/WorkSans-VariableFont_wght.ttf": 385,
	"./footer/footer-icon-1.svg": 339,
	"./footer/footer-icon-2.svg": 340,
	"./footer/footer-icon-3.svg": 341,
	"./footer/footer-icon-4.svg": 342,
	"./footer/footer-icon-5.svg": 343,
	"./footer/footer-icon-6.svg": 590,
	"./footer/footer-icon-dark-1.svg": 344,
	"./footer/footer-icon-dark-2.svg": 345,
	"./footer/footer-icon-dark-3.svg": 346,
	"./footer/footer-icon-dark-4.svg": 347,
	"./footer/footer-icon-dark-5.svg": 348,
	"./footer/footer-icon-dark-6.svg": 591,
	"./fortmaticIcon.png": 333,
	"./header-beta-icon-dark.svg": 592,
	"./header-beta-icon.svg": 593,
	"./iDAI-logo.png": 380,
	"./icn-aethereum.svg": 336,
	"./icn-ledger.svg": 197,
	"./icn-metamask.svg": 233,
	"./ico-cover.svg": 349,
	"./ico-darkmode-dark.svg": 594,
	"./ico-darkmode.svg": 595,
	"./ico-dashboard.svg": 350,
	"./ico-deposit.svg": 198,
	"./ico-grow-light.svg": 596,
	"./ico-grow.svg": 597,
	"./ico-save.svg": 351,
	"./ico-wallet-dark.svg": 598,
	"./ico-wallet.svg": 599,
	"./ico-withdraw.svg": 199,
	"./ico-ycosystem.svg": 352,
	"./ico-zapper.svg": 353,
	"./karet-down-dark.svg": 354,
	"./karet-down-light.svg": 355,
	"./kybernetwork.png": 623,
	"./learn-yearn.png": 624,
	"./ledger.png": 625,
	"./lendf.png": 626,
	"./lendf.svg": 600,
	"./logo-top-dark.svg": 601,
	"./logo-top.svg": 602,
	"./main-background.png": 627,
	"./metamask.png": 628,
	"./metamask.svg": 356,
	"./no-check.svg": 603,
	"./oCurve-logo.svg": 604,
	"./oneinch.svg": 605,
	"./portisIcon.png": 332,
	"./squarelink.png": 334,
	"./synthetix.png": 629,
	"./torus.jpg": 585,
	"./trezor.png": 335,
	"./truffle.png": 630,
	"./trustWallet.png": 331,
	"./uniswap.png": 631,
	"./uniswap.svg": 606,
	"./wBTC-icon.png": 632,
	"./wBTC-logo.png": 381,
	"./walletConnectIcon.svg": 330,
	"./yCRV-logo.jpg": 1407,
	"./yCRV-logo.png": 382,
	"./ycUSDC-logo.png": 383,
	"./ycUSDT-logo.png": 384
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1401;